var map = {
	"./part1/image/1-1.jpg": "e43b",
	"./part1/image/1-2.jpg": "b5ea",
	"./part1/image/1-3.jpg": "f6fe",
	"./part1/image/1-4.jpg": "19bf",
	"./part3/image/3-5.jpg": "8de0",
	"./part3/image/3-5s.jpg": "4c2b",
	"./part4/image/4-3.jpg": "e836",
	"./part4/image/4-3s.jpg": "cf48",
	"./part6/image/6-1.jpg": "88f6",
	"./part6/image/6-1s.jpg": "f958",
	"./part7/image/7-1.jpg": "0050",
	"./part7/image/7-1s.jpg": "ea0b",
	"./part7/image/7-2.jpg": "f911",
	"./part7/image/7-2s.jpg": "f4ce",
	"./part7/image/7-3.jpg": "4f2f",
	"./part7/image/7-3s.jpg": "36c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "126b";